<template>
  <div style="flex:1">
    <!-- 数据源选择器 -->

    <div v-if="!renderer || !renderer.ucIsRoot">
      {{ $t("k_f0c187da") }}
    </div>

    <template v-else>
      <section>
        <a-button @click="openSourceDialog">
          {{ sourceIds.length?$t('k_2fdfb965'):$t('k_c7617bee') }}
        </a-button>
      </section>

      <section v-if="sourceIds.length">
        <a-select
          style="width: 100%"
          :value="$t('k_713188c6')"
          @change="importFieldsFrom"
        >
          <a-select-option
            v-for="id in sourceIds"
            :key="id"
            :value="id"
          >
            {{ id }}
          </a-select-option>
        </a-select>
      </section>
    </template>
  </div>
</template>

<script>
import { $t } from '@/i18n';
import { vueDeepAssign, walkLayout } from '@tencent/ui-core/lib/utils';

export default {
  inject: {
    designer: { from: 'uicore:designer' },
  },
  computed: {
    renderer() {
      return this.designer.renderer;
    },
    sourceIds() {
      return Object.keys(this.renderer?.sources || {});
    },
  },
  methods: {
    async openSourceDialog() {
      this.renderer.openPageletSourcesEditor();
    },
    async importFieldsFrom(sourceId) {
      const { designer } = this;
      if (designer.activeComp?.children?.length) {
        const confirmed = await designer.uc.$confirm($t('k_fd7bb4ad'));
        if (!confirmed) return;
      }

      const layout = designer.uc.fitData(sourceId).find(x => x.type === 'editor')?.layout;
      if (!layout) {
        designer.uc.$alert($t('k_ba7bcc9e'));
        return;
      }

      await designer.replaceCompWith(designer.compPath, layout);
    },

    // 批量转化当前表单的子元素为只读 or 非只读
    // 现在新版本，可以将整个表单 readonly 设置为 true 并让子元素继承，所以这个似乎没啥用了
    // 留作纪念 + 参考代码
    async batchConvertReadonly(newReadonly) {
      const { designer } = this;
      const { uc } = designer;

      await designer.modifyActiveComp((comp) => {
        walkLayout(comp, (step) => {
          const compMeta = uc.components[step.layout.type].meta;
          if (!compMeta?.propsSchema?.fields?.some(x => x?.id === 'readonly' && x.type === 'boolean')) return;

          vueDeepAssign(step.layout, { props: { readonly: !!newReadonly } });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
section + section {
  margin-top: 12px;
}

.label {
  color: #333;
  font-size: 14px;
  line-height: 28px;
}
</style>
